(function () {
  'use strict';

  // =============================================================================
  // 1. CONFIG
  // =============================================================================

  var AFFILIATE_DOMAIN = 'connect.osmosisbeauty.com';
  var AFFILIATE_COOKIE = 'tangent_affiliate_visitor';
  var EXIT_POPUP_SHOWN_COOKIE = 'tangent_exit_popup_shown';
  var COOKIE_EXPIRY_DAYS = 7;

  var QUIZ_CSS_URL = 'https://a.tangent.ai/quiz-inline/2.0.76/assets/index-v2.0.76.css';
  var QUIZ_JS_URL = 'https://a.tangent.ai/quiz-inline/2.0.76/assets/index-v2.0.76.js';

  // Show on any path that starts with one of these prefixes
  // e.g. '/collections' matches /collections, /collections/best-sellers, etc.
  var ALLOWED_PATH_PREFIXES = [
    '/collections',
    '/products',
    '/cart'
  ];

  var COPY_CODE_BTN_SELECTOR = '.tangent_6a69cfcd8ccc13a386da1d94_survey_next_button_custom';
  var TELESTHETICIAN_BTN_SELECTOR = '.tangent_6a69cfd48ccc13a386da1d99_survey_next_button_custom';

  var IDLE_MS = 10000;
  var VELOCITY_THRESHOLD = 2.5; // px per ms
  var TRIGGER_START_DELAY_MS = 10000;

  // =============================================================================
  // 2. COOKIE HELPERS
  // =============================================================================

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
      }
    }
    return null;
  }

  // =============================================================================
  // 3. GATE HELPERS (eligibility checks)
  // =============================================================================

  function markAffiliateFromReferrer() {
    if (
      document.referrer &&
      document.referrer.indexOf(AFFILIATE_DOMAIN) !== -1
    ) {
      setCookie(AFFILIATE_COOKIE, '1', COOKIE_EXPIRY_DAYS);
    }
  }

  function isAffiliateVisitor() {
    return !!getCookie(AFFILIATE_COOKIE);
  }

  function wasPopupShownRecently() {
    return !!getCookie(EXIT_POPUP_SHOWN_COOKIE);
  }

  function isCustomerLoggedIn() {
    var scriptTag = document.currentScript ||
      document.querySelector('script[src*="tangent-exit-popup"]');
    return !!(scriptTag && scriptTag.getAttribute('data-customer-logged-in') === 'true');
  }

  function getNormalizedPath() {
    return (window.location.pathname || '').replace(/\/$/, '') || '/';
  }

  function isAllowedPath(path) {
    return ALLOWED_PATH_PREFIXES.some(function (prefix) {
      var normalized = (prefix || '').replace(/\/$/, '') || '/';
      return path === normalized || path.indexOf(normalized + '/') === 0;
    });
  }

  function shouldInitializePopup() {
    markAffiliateFromReferrer();
    if (isAffiliateVisitor()) return false;
    if (wasPopupShownRecently()) return false;
    if (isCustomerLoggedIn()) return false;
    if (!isAllowedPath(getNormalizedPath())) return false;
    return true;
  }

  // =============================================================================
  // 4. EARLY EXIT — do not build popup if gated out
  // =============================================================================

  if (!shouldInitializePopup()) {
    return;
  }

  // =============================================================================
  // 5. POPUP DOM
  // =============================================================================

  function createPopupOverlay() {
    var el = document.createElement('div');
    el.id = 'tangent_exit_popup_overlay';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Exit popup');

    el.innerHTML = `
      <div id="tangent_exit_popup_card">
        <button id="tangent_exit_popup_close" aria-label="Close popup">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
        <div id="tangent_exit_popup_inner">
          <div
            data-formid="6a69cd408ccc13a386da1c75"
            data-shopid="25009356909"
            data-offset="160"
            id="tangent-main-container"
            data-locale="en"
          ></div>
        </div>
      </div>
    `;

    return el;
  }

  var overlay = createPopupOverlay();
  document.body.appendChild(overlay);

  // =============================================================================
  // 6. QUIZ ASSETS
  // =============================================================================

  function loadQuizAssets() {
    if (!document.querySelector('link[href="' + QUIZ_CSS_URL + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.crossOrigin = 'anonymous';
      link.href = QUIZ_CSS_URL;
      document.head.appendChild(link);
    }

    if (!document.querySelector('script[src="' + QUIZ_JS_URL + '"]')) {
      var script = document.createElement('script');
      script.type = 'module';
      script.crossOrigin = 'anonymous';
      script.src = QUIZ_JS_URL;
      document.body.appendChild(script);
    }
  }

  loadQuizAssets();

  // =============================================================================
  // 7. SHOW / HIDE
  // =============================================================================

  function showPopup() {
    overlay.classList.add('tangent_is_visible');
    document.body.classList.add('tangent_popup_open');
    setCookie(EXIT_POPUP_SHOWN_COOKIE, '1', COOKIE_EXPIRY_DAYS);
  }

  function hidePopup() {
    overlay.classList.remove('tangent_is_visible');
    document.body.classList.remove('tangent_popup_open');
  }

  function markPopupShownAndClose() {
    hidePopup();
    setCookie(EXIT_POPUP_SHOWN_COOKIE, '1', COOKIE_EXPIRY_DAYS);
  }

  // =============================================================================
  // 8. EXIT-INTENT TRIGGERS (desktop mouseleave / mobile scroll + idle)
  // =============================================================================

  var triggered = false;
  var isMobile = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  var idleTimer = null;
  var lastScrollY = 0;
  var lastScrollTime = 0;

  function cleanupMobileTriggers() {
    window.removeEventListener('scroll', onScroll, { passive: true });
    document.removeEventListener('touchstart', resetIdleTimer, { passive: true });
    document.removeEventListener('touchmove', resetIdleTimer, { passive: true });
    document.removeEventListener('click', resetIdleTimer);
    if (idleTimer) {
      clearTimeout(idleTimer);
      idleTimer = null;
    }
  }

  function triggerPopup() {
    if (triggered) return;
    triggered = true;
    cleanupMobileTriggers();
    document.removeEventListener('mouseleave', onMouseLeave);
    showPopup();
  }

  function onMouseLeave(e) {
    if (triggered || e.clientY > 5) return;
    triggerPopup();
  }

  function onScroll() {
    if (triggered) {
      cleanupMobileTriggers();
      return;
    }

    resetIdleTimer();

    var now = Date.now();
    var currentY = window.scrollY;
    var dt = now - lastScrollTime;

    if (dt > 0 && lastScrollTime > 0) {
      var dy = lastScrollY - currentY; // positive = scrolling up
      var velocity = dy / dt;

      if (velocity > VELOCITY_THRESHOLD) {
        triggerPopup();
      }
    }

    lastScrollY = currentY;
    lastScrollTime = now;
  }

  function resetIdleTimer() {
    if (triggered) return;
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(triggerPopup, IDLE_MS);
  }

  function bindDesktopTriggers() {
    document.addEventListener('mouseleave', onMouseLeave);
  }

  function bindMobileTriggers() {
    lastScrollY = window.scrollY;
    lastScrollTime = Date.now();
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('touchstart', resetIdleTimer, { passive: true });
    document.addEventListener('touchmove', resetIdleTimer, { passive: true });
    document.addEventListener('click', resetIdleTimer);
    resetIdleTimer();
  }

  function initExitIntentTriggers() {
    // Small delay after load so listeners don't fire on quick navigation
    window.addEventListener('load', function () {
      setTimeout(function () {
        if (isMobile) {
          bindMobileTriggers();
        } else {
          bindDesktopTriggers();
        }
      }, TRIGGER_START_DELAY_MS);
    });
  }

  // =============================================================================
  // 9. CLIPBOARD
  // =============================================================================

  function fallbackCopyText(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    // Keep in viewport — off-screen can fail on iOS Safari
    textarea.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;';
    document.body.appendChild(textarea);

    var selected = false;
    try {
      textarea.focus();
      textarea.select();
      textarea.setSelectionRange(0, text.length);

      // Extra iOS selection path
      var range = document.createRange();
      range.selectNodeContents(textarea);
      var selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }

      selected = document.execCommand('copy');
    } catch (err) {
      selected = false;
    }

    document.body.removeChild(textarea);
    return selected;
  }

  function copyTextToClipboard(text) {
    if (!text) return false;

    // Preferred modern API (works on HTTPS; must be called from user gesture)
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(text).catch(function () {
        fallbackCopyText(text);
      });
      return true;
    }

    return fallbackCopyText(text);
  }

  function copyDiscountCodeIfPresent() {
    var codeEl = document.getElementById('tngnt_discount_code');
    var code = codeEl ? (codeEl.innerText || codeEl.textContent || '').trim() : '';
    if (code) {
      copyTextToClipboard(code);
    }
  }

  // =============================================================================
  // 10. QUIZ ACTIONS (browsing / copy-code / telesthetician)
  // =============================================================================

  function isBrowsingOption(optionRoot) {
    if (!optionRoot) return false;
    var valueEl = optionRoot.querySelector('[data-value]');
    var value = valueEl
      ? valueEl.getAttribute('data-value')
      : optionRoot.getAttribute('data-value');
    return value === 'browsing';
  }

  function handleExitPopupAction(e) {
    var copyCodeBtn = e.target.closest(COPY_CODE_BTN_SELECTOR);
    var telestheticianBtn = e.target.closest(TELESTHETICIAN_BTN_SELECTOR);
    var option = e.target.closest('.tangent_options_custom');
    var browsing = isBrowsingOption(option);

    if (!browsing && !copyCodeBtn && !telestheticianBtn) return;

    // Copy coupon only for the copy-code CTA (element must still be in the DOM)
    if (copyCodeBtn) {
      copyDiscountCodeIfPresent();
    }

    // Copy-code + telesthetician: modal closes on quiz_submit (below)
    if (copyCodeBtn || telestheticianBtn) return;

    // "Just browsing" — close immediately
    markPopupShownAndClose();
  }

  function bindQuizActionListeners() {
    // Capture phase + pointerdown so we beat React's listeners
    overlay.addEventListener('pointerdown', handleExitPopupAction, true);
    overlay.addEventListener('click', handleExitPopupAction, true);

    // After quiz submit completes, close modal and set 7-day cookie
    window.addEventListener('quiz_submit', function () {
      markPopupShownAndClose();
    });
  }

  // =============================================================================
  // 11. BASIC CLOSE INTERACTIONS (X / overlay / Escape)
  // =============================================================================

  function bindBasicCloseListeners() {
    document.getElementById('tangent_exit_popup_close').addEventListener('click', hidePopup);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        hidePopup();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        hidePopup();
      }
    });
  }

  // =============================================================================
  // 12. INIT
  // =============================================================================

  bindBasicCloseListeners();
  bindQuizActionListeners();
  initExitIntentTriggers();

})();
